import { useEffect, useRef } from 'react';
import type { FormikProps } from 'formik';
import { scrollToElement } from 'Components/utils/scroll/scrollToElement';
// scroll to error after a submit and a validation
export const useAutoScrollToError = (formik: FormikProps<Record<string, unknown>>) => {
  const prevSubmitCount = useRef(0);

  useEffect(() => {
    const { submitCount, isValidating, isValid } = formik;
    const formikErrored = '.formik-errored';

    // React 18 batches state updates so isSubmitting goes true→false in one render.
    // Track submitCount which increments on every submitForm() call.
    // Only update prevSubmitCount after validation completes (isValidating=false)
    // so we don't miss the window between submit and validation finishing.
    if (!isValidating) {
      if (submitCount > prevSubmitCount.current && !isValid) {
        scrollToElement(formikErrored);
        const firstErroredElement = document.querySelector(formikErrored);
        firstErroredElement && firstErroredElement.focus();
      }
      prevSubmitCount.current = submitCount;
    }
  });
};
